import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

export default function NotFound() {
  useSEO({ title: "404 — Fetcher", description: "Page not found.", path: "/404" });
  return (
    <main data-testid="notfound-page" className="grid min-h-screen place-items-center bg-[#0B0F19] px-6 text-center text-white">
      <div>
        <p className="text-7xl font-black tracking-tighter text-[#E86E28]">404</p>
        <h1 className="mt-4 text-2xl font-extrabold tracking-tight">This page hasn't been fetched yet.</h1>
        <p className="mt-2 text-sm font-medium text-white/50">The page you're looking for doesn't exist.</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex rounded-full bg-[#E86E28] px-7 py-3 text-sm font-extrabold text-white transition hover:-translate-y-0.5 hover:bg-[#D95A17]"
        >
          Back to home
        </Link>
      </div>
    </main>
  );
}
